// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"masterTable_tableWrapper__28Jok","afModuleTitle":"masterTable_afModuleTitle__1fBoK"};